<template>
	<sf-data-table
		ref="mesEqipNoTable"
		:pageUnit="pageUnit_"
		:totalSize="totalSize_"
		paging
		:columns="columns"
		:rows="mesEqipNoList"
		:stripe="false"
		:selection="false"
		@changedPage="changedPage"
		height="520px"
	>
	</sf-data-table>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@qms/comm/commpopup/MesEqipNoPopup/store/helpers';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		columns() {
			return [
				{
					label: this.getMessage_('QWCC001317'), //관리번호
					prop: 'mesEqipNo',
					minWidth: '25px',
					clickEvent: this.cpnyNmClick,
					sortable: false,
					highlight: true
				},
				{
					label: this.getMessage_('QWCC001314'), //장비명
					prop: 'mesEqipNm',
					minWidth: '45px',
					clickEvent: this.cpnyNmClick,
					sortable: false,
					highlight: true
				},
				{
					label: this.getMessage_('QWCC001318'), //제조사
					prop: 'mkrNm',
					minWidth: '25px',
					sortable: false,
					highlight: true
				},
				{
					label: this.getMessage_('QWCC001319'), //모델명
					prop: 'mdlNm',
					minWidth: '25px',
					sortable: false,
					highlight: true
				},
				{
					label: this.getMessage_('QWCC001321'), //사용부서
					prop: 'useDeptCd',
					minWidth: '1px',
					sortable: false,
					highlight: true
				},
				{
					label: this.getMessage_('QWCC001321'), //사용부서
					prop: 'useDeptNm',
					minWidth: '25px',
					sortable: false,
					highlight: true
				},
				{
					label: this.getMessage_('QWCC001340'), //사용장소
					prop: 'usePlCd',
					minWidth: '1px',
					sortable: false,
					highlight: true
				},
				{
					label: this.getMessage_('QWCC001340'), //사용장소
					prop: 'usePlNm',
					minWidth: '25px',
					sortable: false,
					highlight: true
				},
				{
					label: this.getMessage_('QWCC001315'), //가동상태
					prop: 'runStCd',
					minWidth: '1px',
					sortable: false,
					highlight: true
				},
				{
					label: this.getMessage_('QWCC001315'), //가동상태
					prop: 'runStNm',
					minWidth: '20px',
					sortable: false,
					highlight: true
				},
				{
					label: this.getMessage_('SWCC000491'), //사양
					prop: 'spcVal',
					minWidth: '20px',
					sortable: false,
					highlight: true
				}
			];
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		async changedPage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			if (!prePage || !prePageUnit) {
				//초기값 셋팅시 이미 searchBar에서 데이터를 조회했기 때문에 중복 조회 하지않도록 처리
				return;
			}
			this.setPagingInfo_({ key: 'currentPage', value: currentPageVal });
			this.setPagingInfo_({ key: 'pageUnit', value: pageUnitVal });
			this.$emit('reload', currentPageVal, pageUnitVal);
		},
		rowClick(row, column, devent) {
			alert(row);
			// this.setState_({ key: 'selectedRow', value: row });
		},
		cpnyNmClick(row) {
			//this.editRow = row;
			this.$emit('SendData', row);
		}
		// ,
		// 	reset() {
		// 		let checkedCount = document.getElementsByClassName('is-checked').length;
		// 		for (let i = 0; i < checkedCount; i++) {
		// 			document.getElementsByClassName('is-checked')[0].classList.remove('is-checked');
		// 		}

		// 		this.$refs.userTable.multipleSelection = [];
		// 		this.selectedRow = null;
		// 	}
		// }
		// ,
		// created() {
		// 	this.columns[2].options = this.gridScrType;
		// 	this.columns[3].options = this.gridMsgTypes;
	}
};
</script>

<style></style>
